import React from 'react'
import SurveyCodeSection from '../../components/survey/test/SurveyCodeSection'
import { Link } from 'react-router-dom'
import { FaExternalLinkAlt } from "react-icons/fa";

const SurveyTestPage = () => {


  return (
    <div>
      <div className='mb-5'>
        <h3 className='h3 mb-3'>SLT/MCI</h3>
        <p className='fs-5'>SLT와 MCI 정밀 검사를 통해 학생의 학습성향을 진단합니다.</p>
      </div>

      <div className='mb-5' >
        <h3 className='h3 mb-3'>SLT/MCI 검사 진행 방법</h3>
        <div style={{ padding: "2rem 1.5rem", border: "1px solid rgb(238, 241, 245)" }}>
          <ol className='lh-base'>
            <li className='mb-3' style={{textIndent:"-1rem", paddingLeft:"1rem"}}>1. 한국가이던스 검사 페이지로 이동 <a href="https://www.guidance.co.kr/Intgr/mainIndex/index.asp" target='_blank' rel="noopener noreferrer" className='text-primary'>(한국 가이던스 바로가기 <FaExternalLinkAlt className='align-center' />)</a></li>
            <li className='mb-3' style={{textIndent:"-1rem", paddingLeft:"1rem"}}>2. SLT/MCI 인증코드를 각각 복사하여 '온라인 심리검사 실시' 인증코드란에 인증코드 복사 후 검사 진행</li>
            <li className='mb-3' style={{textIndent:"-1rem", paddingLeft:"1rem"}}>3. 각 검사 완료 후 아래 '검사완료' 버튼 클릭</li>
            <li className='mb-3' style={{textIndent:"-1rem", paddingLeft:"1rem"}}>
              4. 모든 검사 완료 후, 담당자가 보고서를 작성하여 발급합니다.<br />
              발급된 보고서는 <Link to='/survey/report' className='text-primary'>보고서 확인 페이지</Link>에서 확인 가능합니다. (보고서 발급까지 최대 10일 정도 소요됩니다.)
            </li>
          </ol>
        </div>
      </div>

      <SurveyCodeSection />
    </div>
  )
}

export default SurveyTestPage